const messages: Record<string, string> = {
	'blockedByDevice.headline': 'Bitte verwenden Sie ein Smartphone',
	'blockedByDevice.paragraph.first': 'Dieser Link kann nur auf Smartphones geöffnet werden.',
	'blockedByDevice.paragraph.second':
		'Ein kurzer Tipp: Wenn Sie den Link öffnen, sollten Sie sich in der Nähe des Fahrzeugs befinden und Ihre Unterlagen bereithalten.',
	'button.continue': 'Weiter',
	'button.next': 'Weiter',
	'review.button.next': 'Abschließen',
	'button.photo.take': 'Foto aufnehmen',
	'onboardingStart.headline': 'Hallo! Bitte überprüfen Sie die Angaben, damit wir beginnen können.',
	'onboardingStart.plateNumber': 'Kennzeichen:',
	'onboardingStart.timeout': 'Der Link läuft ab am ',
	'button.start': 'Jetzt starten',
	poweredBy: 'Powered by <ce>ControlExpert</ce>, a <solvd>Solvd</solvd> group company',
	'onboarding.headline': 'Bereit für Ihre digitale Fahrzeugbesichtigung?',
	'onboarding.paragraph': 'Bevor Sie beginnen, beachten Sie bitte Folgendes:',
	'onboarding.documents': 'Halten Sie Ihre Fahrzeugschlüssel bereit.',
	'onboarding.camera': 'Die Fotos werden in Echtzeit mit der Kamera Ihres Smartphones aufgenommen.',
	'onboarding.internet':
		'Sorgen Sie für gute Lichtverhältnisse und eine stabile Internetverbindung.',
	'onboarding.vehicle':
		'Stellen Sie sicher, dass das Fahrzeug sauber und von allen Seiten zugänglich ist und alle Fenster geschlossen sind.',
	'onboarding.terms.before': 'Bitte bestätigen Sie folgendes bevor Sie starten:',
	'onboarding.terms.url': 'Ich stimme den <tclink>Allgemeinen Geschäftsbedingungen</tclink> zu',
	'vehicleFrontLeftPerspectiveImage.title': 'Foto des Fahrzeugs vorne links',
	'vehicleFrontLeftPerspectiveImage.description':
		'Fotografieren Sie das Fahrzeug von vorne links in der Diagonale, wie abgebildet. Achten Sie darauf, dass das gesamte Fahrzeug im Bild ist und das Kennzeichen sichtbar ist.',
	'vehicleRearLeftPerspectiveImage.title': 'Foto des Fahrzeugs hinten links',
	'vehicleRearLeftPerspectiveImage.description':
		'Fotografieren Sie das Fahrzeug von hinten links in der Diagonale, wie abgebildet. Achten Sie darauf, dass das gesamte Fahrzeug im Bild ist und das Kennzeichen sichtbar ist.',
	'vehicleRearRightPerspectiveImage.title': 'Foto des Fahrzeugs hinten rechts',
	'vehicleRearRightPerspectiveImage.description':
		'Fotografieren Sie das Fahrzeug von hinten rechts in der Diagonale, wie abgebildet. Achten Sie darauf, dass das gesamte Fahrzeug im Bild ist und das Kennzeichen sichtbar ist.',
	'vehicleFrontRightPerspectiveImage.title': 'Foto des Fahrzeugs vorne rechts',
	'vehicleFrontRightPerspectiveImage.description':
		'Fotografieren Sie das Fahrzeug von vorne rechts in der Diagonale, wie abgebildet. Achten Sie darauf, dass das gesamte Fahrzeug im Bild ist und das Kennzeichen sichtbar ist.',
	'windshieldImage.title': 'Windschutzscheibe',
	'windshieldImage.description':
		'Fotografieren Sie bitte die Windschutzscheibe. Stellen Sie dabei sicher, dass die gesamte Scheibe und alle Details gut sichtbar sind.',
	'vinPicture.title': 'Fahrzeugidentifikationsnummer (FIN)',
	'vinPicture.description':
		'Machen Sie bitte eine Nahaufnahme Ihrer Fahrzeugidentifikationsnummer. Achten Sie darauf, dass alle Zeichen gut lesbar sind.',
	'button.hint': 'Wo finde ich die FIN?',
	'hint.vin.title': 'Mögliche Positionen der FIN',
	'hint.vin.description':
		'Die Fahrgestellnummer befindet sich in der Regel an einer der folgenden 4 Stellen:',
	'hint.vin.location1':
		'Auf dem Armaturenbrett, sichtbar durch die Windschutzscheibe auf der Fahrerseite.',
	'hint.vin.location2': 'Am Türrahmen der Fahrerseite, in der Nähe des Schlosses.',
	'hint.vin.location3': 'Im Motorraum, häufig auf einem Metallschild.',
	'hint.vin.location4': 'Am vorderen Rahmenende (bei älteren Fahrzeugen).',
	'overallDashboardImage.title': 'Armaturenbrett',
	'overallDashboardImage.description': 'Fotografieren Sie das Armaturenbrett laut Abbildung.',
	'dashboardMileage.title': 'Kilometerstand',
	'vehicleMileage.description':
		'Bitte fotografieren Sie den aktuellen Kilometerstand Ihres Fahrzeugs. Achten Sie darauf, dass alle Ziffern – insbesondere bei digitalen Anzeigen – scharf und vollständig lesbar sind.',
	'dashboardMileage.paragraph.first': 'Geben sie den Kilometerstand ein.',
	'dashboardMileage.placeholder.updated': 'Kilometerstand (km)',
	'review.title': 'Zusammenfassung Ihrer digitalen Vorschadenbesichtigung',
	'review.paragraph.first':
		'Bitte überprüfen Sie vor dem Abschluss, ob alle Angaben korrekt sind.<br/><br/>Nach dem Klick auf „Abschließen“ werden Ihre Fotos und Angaben von uns bestätigt.',
	'review.stepDescription.questions': '(n.a.) Fahrzeuginformationen',
	'review.stepDescription.group.perspectiveImages': 'Überblick der Fahrzeugfotos',
	'review.stepDescription.group.additionalImages': 'Zusätzliche Fotos',
	'review.stepDescription.vehicleFrontLeftPerspective': 'Foto des Fahrzeugs vorne links',
	'review.stepDescription.vehicleRearLeftPerspective': 'Foto des Fahrzeugs hinten links',
	'review.stepDescription.vehicleRearRightPerspective': 'Foto des Fahrzeugs hinten rechts',
	'review.stepDescription.vehicleFrontRightPerspective': 'Foto des Fahrzeugs vorne rechts',
	'review.stepDescription.windshield': 'Windschutzscheibe',
	'review.stepDescription.vinPicture': 'Fahrzeugidentifikationsnummer (FIN)',
	'review.stepDescription.overallDashboard': 'Armaturenbrett',
	'review.stepDescription.mileage': 'Kilometerstand',
	'thanks.headline.first': 'Das Hochladen der Fotos war erfolgreich!',
	'thankYou.message': 'Die übermittelte Besichtigung wird nun von unserem Expertenteam überprüft.',
	'feedback.title': 'Wir freuen uns über Ihr Feedback!',
	'feedback.message':
		'Auf einer Skala von 0 bis 5 (5 ist die höchste Bewertung), wie bewerten Sie Ihre Erfahrung mit der Besichtigungsstrecke?',
	'feedback.helpImprove': 'Helfen Sie uns, besser zu werden (optional)',
	'feedback.button.send': 'Feedback absenden',
	'feedback.error.maxLength': 'Das Feedback darf maximal 500 Zeichen umfassen.',
	'timeout.headline.first': 'Der Besichtigungsauftrag wurde nicht gefunden.',
	'timeout.paragraph.first':
		'Der Link für die Besichtigung ist abgelaufen. Bitte wenden Sie sich bei Fragen an Ihre:n Betreuer:in.',
	'photoUploading.title': 'wird hochgeladen',
	'photoAnalyzing.title': 'wird analysiert',
	'photoLoading.title': 'wird geladen',
	'camera.darkWarning':
		'Die Umgebung ist möglicherweise zu dunkel – bitte sorgen Sie für bessere Lichtverhältnisse.',
	'landscapeModeDetected.title': 'Automatische Drehung aktiviert',
	'landscapeModeDetected.text':
		'Bitte deaktivieren Sie die automatische Bildschirmdrehung auf Ihrem Gerät für eine bessere Nutzung der Kamera.',
	'validationContainer.correct': 'Richtig',
	'button.changeImage': 'Neues Foto machen',
	'button.acceptImage': 'Foto akzeptieren',
	'button.acceptMileage': 'Richtig',
	'button.anotherImage': 'Neues Foto machen',
	'invalidFile.size.title': 'Fotogröße nicht korrekt',
	'invalidFile.size.description': 'Die Dateigröße des Fotos überschreitet das zulässige Maximum.',
	'invalidFile.extension.title': 'Der Dateityp wird nicht unterstützt',
	'invalidFile.extension.description':
		'Dieser Dateityp wird nicht unterstützt. Folgende Dateitypen sind möglich: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
	'connectionError.title': 'Verbindungsfehler',
	'connectionError.description': 'Verbindungsfehler. Bitte laden Sie das Foto erneut hoch.',
	'missingPhoto.title': 'Fehlendes Foto',
	'missingPhoto.description':
		'Ein Foto scheint zu fehlen. Bitte ergänzen Sie das fehlende Foto um fortzufahren.',
};

export default messages;
